<template>
  <div class="word word--layout-image col-span-6 md:col-span-4 lg:col-span-3 shadow-md bg-gray-50">
    <div class="relative h-40 flex justify-center pt-8 bg-sky-50">
      <div class="text-4xl">
        {{ word.preview }}
      </div>

      <div class="absolute bottom-0 text-center w-full word__ja-wrap text-white p-2">
        <div v-if="word.ja">
          <span class="word__ja">{{ word.ja }}</span>
          <TextSpeak :text="word.ja" lang="ja" />
        </div>
        <span v-if="word.ja_kana" class="word__ja-kana block">{{ word.ja_kana }}</span>
      </div>
    </div>

    <div class="p-2 space-y-1">
      <div v-if="word.en">
        <router-link :to="{ path: `/tu-vung/${categorySlug}/${word.ja || word.en}` }" class="hover:underline">
          <span class="word__en">{{ word.en }}</span>
        </router-link>
        <TextSpeak :text="word.en" lang="en" />
      </div>

      <div v-if="word.vi">
        <span class="word__vi">{{ word.vi }}</span>
        <TextSpeak :text="word.vi" lang="vi" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import TextSpeak from '&/TextSpeak.vue'

  defineProps<{
    categorySlug: string
    word: object
  }>()
</script>
